/* eslint no-console: 0 */

require("@rails/ujs").start()
require("@rails/activestorage").start()

import "controllers"

import Vue from 'vue/dist/vue.esm'
import ahMenuItem from '../components/menuItem'
import ahDocumentShow from '../components/documents/show'
import ahDocumentFiles from '../components/documents/files'
import ahDocumentSwitch from '../components/documents/switch'

import 'src/file/direct_uploads.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';

locale.use(lang);

import axios from 'src/common/api.js'
Vue.prototype.$axios = axios;

Vue.use(ElementUI);

import Chartkick from 'vue-chartkick'
Chartkick.configure({language: "ru"})
Vue.use(Chartkick)

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    components: {
      'ah-menu-item': ahMenuItem,
      'ah-document-show': ahDocumentShow,
      'ah-document-files': ahDocumentFiles,
      'ah-document-paid-switch': ahDocumentSwitch
    },

    mounted() {
      require("trix")
      require("@rails/actiontext")
    },

    computed: {
      chart() {
        return { ohlcv: this.$props.data }
      },

      title() {
        return 'test'
      },

      colors() {
        return this.$props.night ? {} : {
          colorBack: '#fff',
          colorGrid: '#eee',
          colorText: '#333',
          colorTitle: '#333'
        }
      },
    },

    data: {
      showDetail: false
    }
  }).$mount('#app')
})
